var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"burger-menu flex flex-column justify-between",class:{'burger-menu_active': _vm.isOpen },on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"burger-menu__item top"}),_vm._v(" "),_c('div',{staticClass:"burger-menu__item bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }